/**
 * YMM Form Field Constants
 * These constants define the field names used by the YMM API
 */

export const YMM_FIELDS = {
  YEAR: 'field_1',
  MAKE: 'field_2',
  MODEL: 'field_3',
} as const;
